import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VTabs,
        {
          attrs: { "center-active": "", "fixed-tabs": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.description")))]),
          _vm.item.type_export_id == 4
            ? _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.input_attributes")))])
            : _vm._e(),
          _vm.item.type_export_id == 4
            ? _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.output_attributes")))])
            : _vm._e(),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.logs")))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.export_events")))]),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            VTabItem,
            [
              _c(
                VContainer,
                { attrs: { fluid: "" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.organization"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.organization,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "organization", $$v)
                              },
                              expression: "info.organization",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.use_case"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.use_case,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "use_case", $$v)
                              },
                              expression: "info.use_case",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_productize_usecase.user")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            VChipGroup,
                            [
                              _c(VChip, { staticClass: "mr-1" }, [
                                _vm._v(_vm._s(_vm.info.owner_name)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.destination_scheme"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              value: (
                                _vm.info.destination_scheme || ""
                              ).replace(/_rlink/gi, ""),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.segment"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.segment,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "segment", $$v)
                              },
                              expression: "info.segment",
                            },
                          }),
                        ],
                        1
                      ),
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Tipo de transformación")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "4" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                filled: "",
                                readonly: "",
                                "hide-details": "auto",
                                dense: "",
                              },
                              model: {
                                value: _vm.item.tipo_registro,
                                callback: function ($$v) {
                                  _vm.$set(_vm.item, "tipo_registro", $$v)
                                },
                                expression: "item.tipo_registro",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Tabla generada en dev (AWS)")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "4" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                filled: "",
                                readonly: "",
                                "hide-details": "auto",
                                dense: "",
                                value: _vm.awsTableName,
                              },
                              on: {
                                "click:append-outer": _vm.copyAwsTableName,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      _vm.item.environment !== "dev"
                        ? _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Tabla generada en prod (AWS)")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.item.environment !== "dev"
                        ? _c(VCol, { attrs: { cols: "9", lg: "4" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "pa-3 grey lighten-4 rounded",
                                staticStyle: {
                                  "white-space": "pre-line",
                                  cursor: "pointer",
                                  color: "rgba(0, 0, 0, 0.87)",
                                },
                                on: {
                                  click: function () {
                                    return _vm.copyText(_vm.awsTableNameProd)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.awsTableNameProd) + " ")]
                            ),
                          ])
                        : _vm._e(),
                      _vm.item.tipo_registro.toLowerCase() !== "binning"
                        ? _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form_attrs_productize_usecase.download_file"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.item.tipo_registro.toLowerCase() !== "binning"
                        ? _c(
                            VCol,
                            { attrs: { cols: "9", lg: "4" } },
                            [
                              [2, 3].indexOf(_vm.item.type_export_id) != -1 &&
                              _vm.item.estado == 2
                                ? _c(VFileInput, {
                                    attrs: {
                                      rules: _vm.rules.file,
                                      accept: ".sql,.txt",
                                      chips: "",
                                      placeholder: _vm.$t(
                                        "form_attrs_productize_usecase.attach_file"
                                      ),
                                      "prepend-icon": "",
                                      "show-size": "",
                                      "truncate-length": "35",
                                      outlined: "",
                                      small: "",
                                      dense: "",
                                      "hide-details": "auto",
                                    },
                                    on: { change: _vm.onFileSelected },
                                    model: {
                                      value: _vm.file,
                                      callback: function ($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file",
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                VBtn,
                                {
                                  attrs: { dense: "", small: "", icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDownloadFile()
                                    },
                                  },
                                },
                                [_c(VIcon, [_vm._v("mdi-download")])],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.description"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              rows: "2",
                            },
                            model: {
                              value: _vm.info.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "description", $$v)
                              },
                              expression: "info.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_productize_usecase.model")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              rows: "1",
                            },
                            model: {
                              value: _vm.info.model,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "model", $$v)
                              },
                              expression: "info.model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  [2, 3].indexOf(_vm.item.type_export_id) != -1
                    ? _c(
                        VRow,
                        { staticClass: "mt-2", attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3", lg: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form_attrs_productize_usecase.exported_table"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(VCol, { attrs: { cols: "9" } }, [
                            _vm.item.group_productive_tables
                              ? _c(
                                  "div",
                                  _vm._l(
                                    _vm.item.group_productive_tables,
                                    function (key, value) {
                                      return _c(
                                        "div",
                                        { key: key },
                                        [_c(VChip, [_vm._v(_vm._s(key))])],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.item.type_export_id == 4
            ? _c(
                VTabItem,
                [
                  _c(VDataTable, {
                    key: _vm.keyTable,
                    staticClass: "text-center table-inca",
                    attrs: {
                      headers: _vm.internal_headers,
                      items: _vm.tableInternalItems,
                      "item-key": "id",
                      "group-by": "attribute_category",
                      responsive: "",
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.attributes.limit,
                      page: _vm.pagination.attributes.current,
                      "show-expand":
                        _vm.item.tipo_registro.toLowerCase() == "binning",
                      expanded: _vm.expandedRows,
                      "single-expand": "",
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.attributes.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(
                          _vm.pagination.attributes,
                          "current",
                          $event
                        )
                      },
                      "update:expanded": function ($event) {
                        _vm.expandedRows = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "group.header",
                          fn: function (ref) {
                            var group = ref.group
                            return [
                              _c("td", { attrs: { colspan: "4" } }, [
                                _c("strong", [_vm._v(_vm._s(group))]),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "expanded-item",
                          fn: function (ref) {
                            var headers = ref.headers
                            var item = ref.item
                            return [
                              _c("td", { attrs: { colspan: headers.length } }, [
                                _c(
                                  "div",
                                  { staticClass: "text-left pa-3" },
                                  [
                                    _c("div", { staticClass: "mb-1" }, [
                                      _vm._v("Intervalos: "),
                                    ]),
                                    _c(VSimpleTable, {
                                      attrs: { dense: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function () {
                                              return [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "caption text--secondary font-weight-medium text-center",
                                                      },
                                                      [_vm._v("Condición")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "caption text--secondary font-weight-medium text-center",
                                                      },
                                                      [_vm._v(" Resultado ")]
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    item.ranges,
                                                    function (r, i) {
                                                      return _c(
                                                        "tr",
                                                        { key: i },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              r.default
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 font-weight-medium",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "En cualquier otro caso"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : r.isNull
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 font-weight-medium",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Cuando el valor es nulo"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 font-weight-medium",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Valor " +
                                                                          _vm._s(
                                                                            r.op
                                                                          ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            r.value
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "body-2 font-weight-bold",
                                                                  staticStyle: {
                                                                    "font-variant-numeric":
                                                                      "tabular-nums",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        r.output
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4190615771
                    ),
                  }),
                  _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination.attributes },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.item.type_export_id == 4
            ? _c(
                VTabItem,
                [
                  _c(VDataTable, {
                    key: _vm.keyTable2,
                    staticClass: "text-center table-inca",
                    attrs: {
                      headers: _vm.output_headers,
                      items: _vm.tableOutputItems,
                      "item-key": "id",
                      responsive: "",
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.output.limit,
                      page: _vm.pagination.output.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.output.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(
                          _vm.pagination.output,
                          "current",
                          $event
                        )
                      },
                    },
                  }),
                  _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination.output },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                key: _vm.keyTable3,
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.logItems,
                  headers: _vm.log_headers,
                  "hide-default-footer": "",
                  "sort-by": _vm.pagination.logs.sort_by,
                  "sort-desc": _vm.pagination.logs.sort_desc,
                  "items-per-page": _vm.pagination.logs.limit,
                  page: _vm.pagination.logs.current,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.logs.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.logs, "current", $event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.creation_date",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VIcon, [_vm._v(" mdi-calendar ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateAndHours(item.creation_date).date
                            ) +
                            " "
                        ),
                        _c(VIcon, [_vm._v(" mdi-clock-outline ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateAndHours(item.creation_date).hour
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.environment",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VChip,
                          {
                            attrs: {
                              small: "",
                              color:
                                item.environment === "prd"
                                  ? "#6200ea"
                                  : "default",
                              "text-color": "white",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.environment
                                    ? item.environment.toUpperCase()
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.logs },
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                key: _vm.keyTable4,
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.exportEvents,
                  headers: _vm.export_events_headers,
                  "hide-default-footer": "",
                  "sort-by": _vm.pagination.exportEvents.sort_by,
                  "sort-desc": _vm.pagination.exportEvents.sort_desc,
                  "items-per-page": _vm.pagination.exportEvents.limit,
                  page: _vm.pagination.exportEvents.current,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.exportEvents.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.exportEvents,
                      "current",
                      $event
                    )
                  },
                },
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.exportEvents },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }